import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2abf53cc&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=2abf53cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf53cc",
  null
  
)

/* custom blocks */
import block0 from "./detail.vue?vue&type=custom&index=0&blockType=graphql"
if (typeof block0 === 'function') block0(component)

export default component.exports